__turbopack_context__.v({
  "actions": "KROrMa_actions",
  "card": "KROrMa_card",
  "desc": "KROrMa_desc",
  "field": "KROrMa_field",
  "fields": "KROrMa_fields",
  "input": "KROrMa_input",
  "inputWrap": "KROrMa_inputWrap",
  "mark": "KROrMa_mark",
  "mobileOnly": "KROrMa_mobileOnly",
  "popupError": "KROrMa_popupError",
  "popupFoot": "KROrMa_popupFoot",
  "popupHead": "KROrMa_popupHead",
  "popupTitle": "KROrMa_popupTitle",
  "rail": "KROrMa_rail",
  "railButton": "KROrMa_railButton",
  "railDesc": "KROrMa_railDesc",
  "railMark": "KROrMa_railMark",
  "railTitle": "KROrMa_railTitle",
  "req": "KROrMa_req",
  "status": "KROrMa_status",
  "statusError": "KROrMa_statusError",
  "text": "KROrMa_text",
  "title": "KROrMa_title",
  "tourChip": "KROrMa_tourChip",
  "wrapButton": "KROrMa_wrapButton",
});
